import React from 'react'
import { useHistory } from "react-router-dom";

import { Button } from '@driftt/dds'
import {
  Layout,
  NavigationHeader 
} from '@driftt/tide-core'
import ChooseImportType from 'components/Imports/ChooseImportType'

const UploadPage = (props) => {
  const history = useHistory()
  return (
    <>
      <NavigationHeader title="Import contacts">
        <Button
          variant='secondary'
          onClick={() => history.push('/imports/logs')}
        >
          Import logs
        </Button>
      </NavigationHeader>
      <Layout>
        <ChooseImportType {...props} />
      </Layout>
    </>
  )
}

export default UploadPage
